/* eslint-disable jsx-a11y/anchor-is-valid */
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import TwitterIcon from "@mui/icons-material/Twitter";
import eventOrg from "../../assets/icons/planner.png";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { usePersistentState } from "../../contexts/global-context";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Color from "../../theme/color";
import { Divider, Skeleton, useMediaQuery } from "@mui/material";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import ReactPlayer from "react-player";

export const InfoCard = () => {
  const [state]: any = usePersistentState();
  const EventOrganizerDetails: any = state?.Event?.organizer;
  const EventVenueDetails: any = state?.EventVenue;
  const EventScheduleDetails: any = state?.EventSchedule;
  const isMobile = useMediaQuery("(max-width: 800px)");
  var hostName = window.location.protocol + "//" + window.location.host;

  const smoothScroll = (target: string) => {
    const $target = document.querySelector(target);
    if ($target) {
      window.scrollTo({
        top: $target.getBoundingClientRect().top + window.pageYOffset,
        behavior: "smooth",
      });
    }
  };
  return (
    <Grid item xs={12} sm={3} md={4} sx={Styles.mainGrid}>
      <div style={(Styles.mainDiv, { marginTop: 30 })}>
        <div style={{ margin: isMobile ? "20px 0 20px 0" : "20px", ...Styles.organizerBody }}>
          <Card>
            <CardContent style={Styles.organizerCardHeader}>
              <Typography variant="h6">Organizer Details</Typography>
            </CardContent>
            <CardContent style={Styles.organizerCardContent}>
              {
                EventOrganizerDetails?.companyName ? (<img src={eventOrg} alt="Organizer" style={Styles.organizerCardProfileImages} />) :
                  (<Skeleton animation="wave" variant="circular" style={{ margin: "8px 18px" }} width={25} height={25} />)
              }

              <div style={Styles.organizerCardTextBody}>
                {
                  EventOrganizerDetails?.companyName ?
                    (<a href="#"><Typography variant="body1" style={Styles.organizerCardText}>{EventOrganizerDetails?.companyName}</Typography></a>) :
                    (<Skeleton animation="wave" variant="text" sx={{ fontSize: "1rem" }} style={{ width: "150px" }} />)
                }
              </div>
            </CardContent>
          </Card>
        </div>

        <div style={{ margin: isMobile ? "20px 0 20px 0" : "20px", ...Styles.venueBody }}>
          <Card>
            <CardContent style={Styles.venueCardHadar}><Typography variant="h6">Venue</Typography></CardContent>
            <CardContent style={Styles.venueCardContent}>
              {
                EventVenueDetails?.address1 ?
                  (<LocationOnIcon style={Styles.venueIcon} />) :
                  (<Skeleton animation="wave" variant="circular" style={{ margin: "8px 18px" }} width={25} height={25} />)
              }
              {
                EventVenueDetails?.address1 ?
                  (
                    <Typography variant="body1" style={Styles.venueCardText}>
                      {EventVenueDetails?.isVirtualEvent ? (
                        <>{"Virtual Event"}</>
                      ) : (
                        <>
                          <Typography>
                            {EventVenueDetails?.venueName} {":"} {EventVenueDetails?.address1}, {EventVenueDetails?.city}
                            , {EventVenueDetails?.state},{" "}
                            {EventVenueDetails?.country},{" "}
                            {EventVenueDetails?.zipCode}
                          </Typography>
                        </>
                      )}
                    </Typography>
                  ) :
                  (<Skeleton animation="wave" variant="text" sx={{ fontSize: "1rem" }} style={{ width: "250px" }} />)
              }
            </CardContent>
          </Card>
        </div>
        <div style={{ margin: isMobile ? "20px 0 20px 0" : "20px", ...Styles.scheduleBody }}>
          <Card>
            <CardContent style={Styles.scheduleCardHeader}>
              <Typography variant="h6"> Schedule </Typography>
            </CardContent>
            <CardContent style={{ display: "block", alignItems: "center", padding: "5px 10px 5px 10px", justifyContent: "start", }}>
              {
                EventScheduleDetails?.length > 0 ? (
                  EventScheduleDetails?.map(
                    (scheduleItem: any, index: number) => {
                      const startDate = new Date(scheduleItem?.startDate);
                      const endDate = new Date(scheduleItem?.endDate);
                      const timeZone = EventVenueDetails?.timeZone?.abbreviation;
                      const optionsStart: any = {
                        weekday: "short",
                        year: "numeric",
                        day: "numeric",
                        month: "short",
                        hour: "2-digit",
                        minute: "2-digit",
                      };
                      const optionsEnd: any = {
                        weekday: "short",
                        year: "numeric",
                        day: "numeric",
                        month: "short",
                        hour: "2-digit",
                        minute: "2-digit",
                      };
                      return (
                        <>
                          <div key={scheduleItem.id} style={{ display: "flex", alignItems: "center", padding: "5px 0 5px 0", justifyContent: "start" }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                              <div style={{ margin: "10px 20px 10px 20px" }}>
                                <AccessTimeIcon style={{ color: Color.secondary, marginTop: 3, height: 22 }} />
                              </div>
                              <div>
                                <Typography variant="body1" style={{ color: "#000", fontSize: "15px", fontWeight: "500" }}>
                                  {
                                    startDate.toLocaleString("en-us", optionsStart)
                                  }
                                  {""} -{" "}
                                </Typography>
                                <Typography variant="body1" style={{ color: "#000", display: "flex", fontSize: "15px", fontWeight: "400" }}>
                                  {endDate.toLocaleString("en-us", optionsEnd)}
                                  {"  "}
                                  <Typography style={{ color: Color.color13, fontSize: "14px", fontWeight: "400" }}>
                                    {"  "} {"  "}({timeZone})
                                  </Typography>
                                </Typography>
                              </div>
                            </div>
                          </div>

                          {index !== EventScheduleDetails.length - 1 && (<Divider style={{ color: "red" }} />)}
                        </>
                      );
                    }
                  )
                ) : (
                  <div style={{ display: "flex" }}>
                    <Skeleton animation="wave" variant="circular" style={{ height: "22px", width: "22px", margin: "20px 20px 10px 20px" }} />
                    <div>
                      <Skeleton variant="text" sx={{ fontSize: "1rem", width: "300px", marginTop: "7px" }} />
                      <Skeleton variant="text" sx={{ fontSize: "1rem", width: "300px", marginBottom: "7px" }} />
                    </div>
                  </div>
                )}
            </CardContent>
          </Card>
        </div>
        <div style={{ margin: isMobile ? "20px 0 20px 0" : "20px", ...Styles.organizerBody }}>
          <Card>
            <CardContent style={Styles.organizerCardHeader}>
              <Typography variant="h6">Share</Typography>
            </CardContent>
            <CardContent style={Styles.organizerCardHeader}>
              <div style={{ textAlign: "start" }}>
                <div>
                  <WhatsappShareButton
                    style={Styles.shareButton}
                    url={`${hostName}/event/${state?.Event?.eventRouting}`}
                  >
                    <IconButton sx={{ color: "#075e54" }} aria-label="WhatsApp">
                      <WhatsAppIcon />
                    </IconButton>
                  </WhatsappShareButton>
                  <FacebookShareButton style={Styles.shareButton} url={`${hostName}/event/${state?.Event?.id}/${state?.Event?.eventRouting}`}>
                    <IconButton sx={{ color: "#1877F2" }} color="primary" aria-label="Facebook">
                      <FacebookIcon />
                    </IconButton>
                  </FacebookShareButton>
                  <LinkedinShareButton style={Styles.shareButton} url={`${hostName}/event/${state?.Event?.id}/${state?.Event?.eventRouting}`}>
                    <IconButton sx={{ color: "#0A66C2" }} aria-label="LinkedIn">
                      <LinkedInIcon />
                    </IconButton>
                  </LinkedinShareButton>
                  <EmailShareButton style={Styles.shareButton} subject="I wanted you to see this site" url={`${hostName}/event/${state?.Event?.id}/${state?.Event?.eventRouting}`} >
                    <IconButton sx={{ color: "#EA4335" }} color="primary" aria-label="Email" >
                      <EmailIcon />
                    </IconButton>
                  </EmailShareButton>
                  <TwitterShareButton style={Styles.shareButton} url={`${hostName}/event/${state?.Event?.id}/${state?.Event?.eventRouting}`}>
                    <IconButton sx={{ color: "#1DA1F2" }} color="primary" aria-label="Twitter">
                      <TwitterIcon />
                    </IconButton>
                  </TwitterShareButton>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        <div style={{ position: isMobile ? "relative" : "static", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          {isMobile ? (
            // <>
            //   {state?.isInViewport === false ? (
            //     <div
            //       style={{
            //         position: "fixed",
            //         bottom: 0,
            //         width: "100%",
            //         textAlign: "center",
            //       }}
            //     >
            //       <a
            //         onClick={(e: any) => {
            //           e.preventDefault();
            //           smoothScroll("#resume");
            //         }}
            //       >
            //         <Button
            //           style={{
            //             width: "100%",
            //             backgroundColor: Color.primary,
            //             borderRadius: 0,
            //           }}
            //           classes={{ root: "no-border-radius" }}
            //           variant="contained"
            //           size="large"
            //         >
            //           Buy Ticket5
            //         </Button>
            //       </a>
            //     </div>
            //   ) : null}
            // </>
            <></>
          ) : (
            <>
              {state?.isInViewport === false ? (
                <div style={{ display: "flex", width: "100%", justifyContent: "center", }}>
                  <a style={{ width: "90%" }} onClick={(e: any) => { e.preventDefault(); smoothScroll("#resume"); }}>
                    <Button style={{ width: "100%", backgroundColor: Color.primary }} variant="contained" size="large">Buy Ticket</Button>
                  </a>
                </div>
              ) : null}
            </>
          )}
        </div>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "15px" }}>
          {
            state?.Event?.videoUrl ? (
              <div style={{ width: isMobile ? "100%" : "93%" }}>
                <ReactPlayer style={{ borderRadius: "5.25rem", }} url={state?.Event?.videoUrl} controls={true} width={"100%"} />
              </div>
            ) : ("")
          }
        </div>
      </div>
    </Grid>
  );
};

const Styles: any = {
  mainGrid: {
    position: "sticky",
    top: 0,
    width: "100%",
    maxHeight: "calc(190vh - 90px)",
    // overflowY: "auto",
    marginBottom: 5,
  },
  mainDiv: {
    textAlign: "center",
  },
  organizerBody: {
    borderRadius: "10px",
    backgroundColor: "#fff",
  },
  organizerCardHeader: {
    borderBottom: "1px solid #DDD",
    padding: "10px",
    justifyContent: "start",
    display: "flex",
  },
  organizerCardContent: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    justifyContent: "start",
  },
  organizerCardProfileImages: {
    borderRadius: "10px",
    maxWidth: "5%",
    height: "auto",
    margin: "10px 20px 10px 20px",
  },
  organizerCardTextBody: { display: "flex", flexDirection: "column" },
  organizerCardText: { color: "#000" },

  venueBody: {
    borderRadius: "10px",
    backgroundColor: "#fff",
    alignItems: "center",
  },
  venueCardHadar: {
    borderBottom: "1px solid #DDD",
    padding: "10px",
    justifyContent: "start",
    display: "flex",
  },
  venueCardContent: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    justifyContent: "start",
  },
  venueIcon: {
    fontSize: "20px",
    color: "#333",
    margin: "10px 20px 10px 20px",
  },
  venueCardText: { color: "#000" },
  scheduleBody: {
    borderRadius: "10px",
    backgroundColor: "#fff",
    alignItems: "center",
  },
  scheduleCardHeader: {
    borderBottom: "1px solid #DDD",
    padding: "10px",
    justifyContent: "start",
    display: "flex",
  },
  shareButton: { marginLeft: 5, marginRight: 5 },
};
